import React, { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import Button from '../../components/Button/Button';
import Rate from '../../components/Rate/Rate';
import { logging } from '../../actions/log';
import styles from './SoftDetailSimple.module.less';
import Btn from '../../components/Btn/Btn';
import { setFasterProduct } from '../../actions/layout';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ softDetails, match }) => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  useEffect(() => {}, [dispatch]);
  const handleFasterProduct = () => {
    dispatch(
      setFasterProduct({
        soft: { ...softDetails, bizInfo: match.params.bizInfo },
        info: { isFasterProduct: true },
        logInfo: { source: 'AppDetail' },
      }),
    );
    // 打桩
    dispatch(
      logging({
        category: 'C',
        action: 'Accelerate',
        label: '',
        param2: {
          source: 'AppDetail',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: softDetails.softID || softDetails.SoftID,
          softType: '0',
          accelerate: softDetails.appRecommend && softDetails.appRecommend.softId,
        },
        param3: softDetails.bizInfo,
      }),
    );
  };
  return (
    <div className={styles.detail_simple}>
      <div className="detail_logo">
        <img className="detail_img" src={softDetails.logoFile} />
      </div>
      <div className="detail_info">
        <div className="detail_info_line">
          <div className="detail_info_title">{softDetails.softName}</div>
          {softDetails.score > 70 && (
            <div className="detail_info_score">
              <Rate score={(softDetails.score / 20).toFixed(0)} />
            </div>
          )}
        </div>
      </div>
      <div className="detail_opt">
        {softDetails && softDetails.appRecommend && (
          <Btn className={styles.fasterProductBtn} handleClick={handleFasterProduct}>
            <div className={styles.fasterProductIcon}></div>
            <span className={styles.fasterProductBtnText}>加速</span>
          </Btn>
        )}
        <Button
          soft={{ ...softDetails, bizInfo: softDetails.bizInfo }}
          info={{
            className: styles.soft_btn,
            className_busing: styles.soft_btn_busing,
            className_open: styles.soft_button_open,
            text: '立即安装',
            isCompetitive: true,
            isFasterProduct: true,
          }}
          logInfo={{
            source: 'AppDetail',
            isSearch:
              logInfoData.source_p &&
              (logInfoData.source_p.indexOf('Search') > -1 ||
                logInfoData.source_p.indexOf('Search_Try') > -1 ||
                logInfoData.source_p.indexOf('Search_Lenovo') > -1),
          }}
        />
      </div>
    </div>
  );
});
